import React, { Component } from 'react';
import { Segment, Header, Button, Grid, Image } from 'semantic-ui-react'
import _ from 'underscore';

import GpIconImage from './gp_icon.png';
import TcmIconImage from './tcm_icon.png';
import DentalIconImage from './dental_icon.png';

const clinicsTypes = {
    0: 'Others',
    1: 'General Practitioners', // 1
    2: 'Specialists', // 2
    3: 'Dental', // 3
    4: 'Xray',
    5: 'Physiotherapy',
    6: 'Traditional Chinese Medicine', // 4
    7: 'Polyclinic',
    8: 'Hospital',
    9: 'Lab',
};

const fixedClinicTypes = {
    1: 'General Practitioners', // 1
    2: 'Specialists', // 2
    3: 'Dental', // 3
    6: 'Traditional Chinese Medicine', // 4
}

const clinicsTypeImages = {
    0: GpIconImage,
    1: GpIconImage,
    2: GpIconImage,
    3: DentalIconImage,
    4: GpIconImage,
    5: GpIconImage,
    6: TcmIconImage,
    7: GpIconImage,
    8: GpIconImage,
    9: GpIconImage,
};

class FindPanelClinicsWidget extends Component {
    renderFixedSelectionButtonOptions() {
        const renderOutput = [];
        _.mapObject(fixedClinicTypes, (value, key) => {
            // const foundMatchingdata = _.indexOf(this.props.clinicsTypeList, parseInt(key));
            // const isDisabled = (foundMatchingdata === -1) ? true : false;
            let isDisabled
            if (this.props && this.props.configBenefit && this.props.configBenefit.featuresConfig && this.props.configBenefit.featuresConfig.allowClinicLocator) {
                const matchData = this.props.clinicsTypeList.filter((data) => data.value == key);
                isDisabled = matchData.length > 0 ? false : true
            } else {
                isDisabled = true
            }
            renderOutput.push(
                <Button
                    key={key}
                    onClick={() => this.handleSelectionClick(value)}
                    disabled={isDisabled}
                >
                    <Image src={clinicsTypeImages[key]} fluid/>
                    {value}
                </Button>
            );
        });
        return renderOutput;
    }
    renderSelectionButtonOptions() {
        return _.map(this.props.clinicsTypeList, (clinicType) => {
            const data = clinicsTypes[clinicType];
            return (
                <Button
                    onClick={() => this.handleSelectionClick(clinicType)}
                >
                    <Image src={clinicsTypeImages[clinicType]} fluid/>
                    {data}
                </Button>
            );
        });
    }
    handleSelectionClick = (clinicTypeSelected) => {
        this.props.history.push(`/app/cliniclocator?type=${clinicTypeSelected}`);
    }
    render() {
        console.log(this.props);
        return (
            <div>
                <Header as='h4' attached='top' block>
                    Find Panel Clinics
                </Header>
                <Segment attached>
                    <Button.Group widths='6' basic>
                        {this.renderFixedSelectionButtonOptions()}
                    </Button.Group>
                </Segment>
            </div>
        );
    }
}

export default FindPanelClinicsWidget;